import { isAuthorized, selectedSectionAtom, smetaStore } from "../atoms";
import { isSessionActive, updateSection } from "./MainPage/Tools/Tools";
import { setClientInfo } from "./Singin/SingIn";

// Интервал проверки «живости» страницы. Если между тиками прошло намного больше, значит компьютер спал.
const heartbeatInterval = 10000;

const sleepThreshold = 120000;

let isRestoring = false;

export const isSessionRestoring = () => isRestoring;

export const restoreSessionAfterIdle = async () => {
  if (isRestoring) return;
  isRestoring = true;
  try {
    const { active } = await isSessionActive();
    if (!active) {
      // как при загрузке страницы: маршрут /main без авторизации переводит на вход
      localStorage.setItem("login", "");
      smetaStore.set(isAuthorized, false);
      return;
    }
    await setClientInfo();
    if (smetaStore.get(selectedSectionAtom).ID) updateSection(undefined, undefined);
  } catch (error) {
    console.warn("Не удалось восстановить сессию после простоя", error);
  } finally {
    isRestoring = false;
  }
};

export const watchWakeUp = (onWakeUp: (offlineSince: number) => void) => {
  let lastTick = Date.now();
  let offlineSince: number | null = null;

  const checkSleep = () => {
    const now = Date.now();
    if (now - lastTick > sleepThreshold) onWakeUp(lastTick);
    lastTick = now;
  };
  // при возвращении во вкладку проверяем сразу, не дожидаясь следующего тика
  const handleVisibilityChange = () => {
    if (document.visibilityState === "visible") checkSleep();
  };
  const handleOffline = () => {
    offlineSince = Date.now();
  };
  const handleOnline = () => {
    onWakeUp(offlineSince ?? Date.now());
    offlineSince = null;
  };

  const heartbeat = setInterval(checkSleep, heartbeatInterval);
  document.addEventListener("visibilitychange", handleVisibilityChange);
  window.addEventListener("offline", handleOffline);
  window.addEventListener("online", handleOnline);
  return () => {
    clearInterval(heartbeat);
    document.removeEventListener("visibilitychange", handleVisibilityChange);
    window.removeEventListener("offline", handleOffline);
    window.removeEventListener("online", handleOnline);
  };
};
